import React from 'react';
import { Button, Typography } from '@guildeducationinc/recess';
import { ResetPasswordEmailResponse, useAuth } from '@guildeducationinc/guild-auth';
import '../EditProfile.scss';
import { datadogRum } from '@datadog/browser-rum';
import { clickable } from '@src/analytics';

type Props = {
  setShowEmailSent: React.Dispatch<React.SetStateAction<any>>;
  setShowEmailError: React.Dispatch<React.SetStateAction<any>>;
};

const sendResetEmailClickable = () => {
  clickable({
    loggedIn: true,
    product: 'account',
    tag: 'change_password',
    text: 'send_reset_email',
    type: 'button',
  });
};

const ChangePassword: React.FC<Props> = ({ setShowEmailSent, setShowEmailError }) => {
  const handleSentEmailError = (result: ResetPasswordEmailResponse) => {
    setShowEmailError(true);
    datadogRum.addError(result, {
      message: 'There was an error sending the password reset email',
    });
  };

  const { resetPasswordEmailHandler } = useAuth();
  const resetClickHandler = async () => {
    sendResetEmailClickable();
    const result = await resetPasswordEmailHandler();
    result?.success === true ? setShowEmailSent(true) : handleSentEmailError(result);
  };

  return (
    <div>
      <Typography variant='h3'>Change password</Typography>
      <div className='padding--bottom_32 padding--top_16 width--9/12'>
        <div>
          Click the button below and we&apos;ll send you an email with instructions to reset your
          password. If you change your password, you&apos;ll need to sign back in to your Guild
          account.
        </div>
      </div>
      <div>
        <Button appearance='ghost' onClick={resetClickHandler} testid='send-password-reset-email'>
          Send reset email
        </Button>
      </div>
    </div>
  );
};

export default ChangePassword;
